const fieldValidation = {
  required: 'จำเป็นต้องระบุ{{fieldName}}',
  pattern: '{{fieldName}} is invalid',
  channelUnlinked:
    'The channel previously selected is disconnected, please select another/connect the channel again.',
};

export default fieldValidation;
